(function () {
    "use strict";

    // @ngInject
    function PipelineControllerCtor($scope, $injector, $document, $timeout, $,moment, FeaturesService,
                                    UsersManager, CompaniesManager, ReferralsManager, Enums, ContactsManager, $location,
                                    PopupMessageService, UserService, ModalService, UiPersistenceService, OnboardingService,
                                    DeviceService, AbTestService, AnalyticsService, NavigationService, InitialAppLoadParamsService, $stateParams, $translate) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'PipelineController';
        this.currUser = UsersManager.getCurrUser();
        this.selectedUser = this.currUser;
        this.company = CompaniesManager.getCurrCompany();

        this.CompaniesManager = CompaniesManager;
        this.AnalyticsService = AnalyticsService;
        this.DeviceService = DeviceService;
        this.PopupMessageService = PopupMessageService;
        this.ModalService = ModalService;
        this.UiPersistenceService = UiPersistenceService;
        this.ContactsManager = ContactsManager;
        this.Enums = Enums;
        this.UsersManager = UsersManager;
        this.UserService = UserService;
        this.AbTestService = AbTestService;
        this.NavigationService = NavigationService;
        this.moment = moment;
        this.PopupMessageService = PopupMessageService;
        this.OnboardingService = OnboardingService;
        this.$translate = $translate;

        this.isOnboardingActive = OnboardingService.isOnboardingActive();
        this.onboardingCreateEventTooltipStep = OnboardingService.OnboardingSteps.createEventTooltip;
        this.$timeout = $timeout;
        this.isTouchDevice = this.DeviceService.checkIfTouchDevice();
        this.openningPipelineSettings = false;
        var onboardingMenuPersistenceHash = this.UiPersistenceService.getUiPersistence(this.UiPersistenceService.keys.leftPanelView, {
            showOnboardingOptionsMenuOnLoad: true,
            persistOnboardingOptionsMenu: false
        });
        this.appState.isFileRouteAndClientMode = false;
        this.InitialAppLoadParamsService = InitialAppLoadParamsService;
        this.pipelineOnboardingIsOpen = false;

        this.onboardingMenuHasBeenSeen = !onboardingMenuPersistenceHash.showOnboardingOptionsMenuOnLoad;

        this.onboardingOverviewTaskAccomplished = this.OnboardingService.getOnboardingOverviewTaskAccomplished();
        // Update the number in the onboarding icon badge every time when it changes
        this.OnboardingService.on('onboardingOverviewTaskAccomplished', function hanldeOnboardingOverviewChagned(tasksHash) {
            this.onboardingOverviewTaskAccomplished = tasksHash;
        }.bind(this));

        // should this be moved to setup guide?
        this.InitialAppLoadParamsService.cleanParamsFromView('discountCode', 'promo');

        this.OnboardingService.triggerTrialIfNeeded($stateParams.shouldStartTrial);

        this.OnboardingService.triggerPayWallIfOn();

        this.AbTestService.convertAbTest(this.Enums.ABTests.facebookTrialerDiscount);

        this.showActiveWorkspaces = true;

        var self = this;

        UserService.showGmailRevokedPopup(this.currUser);

        this.stripeMigrationWarning = [
            {
                startDate: '03/02/2020',
                endDate: '03/12/2020',
                text: 'PIPELINE.STRIPE_BANNER._FIRST_NOTICE_',
                class: 'nx-banner--info'
            },
            {
                startDate: '03/12/2020',
                endDate: '03/26/2020',
                text: 'PIPELINE.STRIPE_BANNER._SECOND_NOTICE_',
                class: 'nx-banner--info'
            },
            {
                startDate: '03/26/2020',
                endDate: '03/31/2021',
                text: 'PIPELINE.STRIPE_BANNER._LAST_CALL_',
                class: 'nx-banner--alert'
            }

        ];

        this.today = this.moment();

        var _init = function _init() {
            this.isCompanyModerator = this.currUser.hasCompanyModeratorPermissions();
            this.otherTeamMembers = this.company.getOtherCompanyMembers();

            this.stripeMigrationObject = this.getStripeWarningObject();

            // show the mobile app intro only to activated members who logged in on desktop!
            if (this.currUser.isActivated() && !this.isTouchDevice) {

                var introPersistenceHash = this.UiPersistenceService.getUiPersistence(this.UiPersistenceService.keys.mobileAppIntro, {
                    dontShow: false
                });
                // if (!this.currUser.isMobileActive() && (!introPersistenceHash || !introPersistenceHash.dontShow)) {
                //
                //     this.ModalService.openIntroTipModal().finally(function(result){
                //         //set ui persistence
                //         UiPersistenceService.setUiPersistence(UiPersistenceService.keys.mobileAppIntro, {dontShow: true});
                //
                //     });
                // }

                //////////////////// QUICKBOOKS INTRO MODAL ///////////////////////
                // if (!introPersistenceHash || !introPersistenceHash.dontShow) {
                //     this.ModalService.openIntroTipModal().finally(function(result){
                //         //set ui persistence
                //         UiPersistenceService.setUiPersistence(UiPersistenceService.keys.quickbooksIntro, {dontShow: true});
                //
                //     });
                //
                // }


                var leadSourceModalIntroHash = this.UiPersistenceService.getUiPersistence(this.UiPersistenceService.keys.leadSourceModalIntro, {
                    dontShow: false
                });

                if ((this.currUser.isMobileActive() || introPersistenceHash.dontShow) && !leadSourceModalIntroHash.dontShow) {
                    this.ModalService.openLeadSourceModal().finally(function (result) {
                        UiPersistenceService.setUiPersistence(UiPersistenceService.keys.leadSourceModalIntro, {dontShow: true});
                    });
                }

            }

        }.bind(this);

        if (this.company.wasFullyFetched()) {
            _init();
        } else {
            this.registerOnce(this.company, 'success', _init);
        }

        // open settings on load - used on new setup guide
        // customize used in email link
        if ($stateParams.openSettingsOnLoad || $stateParams.customize) {
            this.openPipelineSettings();
        }

        if ($stateParams.showFeatureOnboarding || $stateParams.onboarding) {
            this.showPipelineOnboarding();
        }
    }

    Controllers.PipelineController = Class(Controllers.BaseController, {
        constructor: PipelineControllerCtor,

        showOnboardingCreateEventPopover: function showOnboardingCreateEventPopover() {
            return this.isOnboardingActive && this.OnboardingService.isStep(this.onboardingCreateEventTooltipStep) && !this.DeviceService.checkIfMobileSize() && this.currUser.isInTrial();
        },

        reloadAndRefreshCurrentPage: function reloadAndRefreshCurrentPage() {
            // Adds {showFeatureOnboarding: false} because we do not want to show the
            // pipeline tour when closing the pipelineSettings modal
            this.$state.go(this.AppStates.root_core_navigation_pipeline, {showFeatureOnboarding: false}, {reload: true});
        },

        openPipelineSettings: function openPipelineSettings() {
            if (this.openningPipelineSettings) {
                //prevent double clicking the settings
                return;
            }
            this.openningPipelineSettings = true;
            this.toggleCustomizePopover(false);

            if (this.company.wasFullyFetched()) {
                this.openSettingDialogInternal();
            } else {
                this.CompaniesManager.getCurrCompany(true);
                this.registerOnce(this.company, 'success', this.openSettingDialogInternal.bind(this));
            }
        },

        openSettingDialogInternal: function openSettingDialogInternal() {
            this.ModalService.openPipelineSettingsModal(this.currUser.company).then(
                function success(result) {
                    if (result !== 'dismissed') {
                        this.reloadAndRefreshCurrentPage();
                    }
                }.bind(this),
                function fail(error) {
                    if (error) {
                        return this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, 'PIPELINE.SETTINGS._ERROR_UPDATING_NEW_PIPELINE_STAGES_', function okHanlder() {
                            this.reloadAndRefreshCurrentPage();
                        }.bind(this));
                    }

                    // otherwise this could be just a dismiss of the dialog with the escape key. do nothing and let it close
                }.bind(this))
                .finally(function () {
                    this.openningPipelineSettings = false;
                }.bind(this));
        },

        hasOnboardingMenuBeenClosed: function hasOnboardingMenuBeenClosed() {
            return this.OnboardingService.getOnboardingMenuClosed();
        },

        showPipelineOnboarding: function showPipelineOnboarding() {
            this.pipelineOnboardingIsOpen = true;
            
            this.ModalService.openPipelineOnboardingModal()
                // Clicking 'Close', 'Done', or 'Customize'
                .then(this.onPipeLineOnboardingClose.bind(this))
                // Keypress 'Esc' or clicking outside modal
                .catch(this.onPipeLineOnboardingClose.bind(this));
        },

        onPipeLineOnboardingClose: function onPipeLineOnboardingClose(data) {
            if (data && data.didClickCustomize) {
                this.openPipelineSettings();
            } else {
                if (this.currUser.is_company_owner && !this.DeviceService.checkIfMobileSize()) {
                    var companyType = this.currUser.company.company_type;
                    var companyTypePlural = (this.Enums.ExtendedCreativeTypesPlural[companyType] && companyType !== 'other') ? this.Enums.ExtendedCreativeTypesPlural[companyType] : 'members';
                    this.customizePopoverMessage = this.$translate.instant('PIPELINE.TOOLTIPS._CUSTOMIZE_', {
                        industryPlural: companyTypePlural.toLowerCase()
                    });
                    this.toggleCustomizePopover(true);
                }
            }
            this.pipelineOnboardingIsOpen = false;
            this.UiPersistenceService.setUiPersistence(this.UiPersistenceService.keys.pipelineOnboarding, {seen: true});
        },

        toggleCustomizePopover: function toggleCustomizePopover(show) {
            this.showCustomizePopover = show;
        },

        isPendingStripeMigration: function isPendingStripeMigration() {
            return !!this.company.pending_stripe_migration && this.currUser.isCompanyOwner();
        },

        getStripeWarningObject: function getStripeWarningObject() {

           var stripeWarning = this.stripeMigrationWarning.filter(function(obj) {

               var beginning = this.moment(obj.startDate).format('ddd, MMM DD, YYYY');
               var end = this.moment(obj.endDate).format('ddd, MMM DD, YYYY');

               return this.moment(this.today).isBetween(beginning, end);

           }.bind(this));

           if (stripeWarning && stripeWarning.length === 0) {
                stripeWarning.text = null;
                stripeWarning.class = '';
           } else {
               stripeWarning = stripeWarning[0];
           }

           return stripeWarning;
        }

    });
}());
